import { encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class FairDetailsStore {
  loading = false;
  total = 0;
  taxiParameterList = [];
  vehicleTypeArr = [];
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,
      total: observable,
      taxiParameterList: observable,
      vehicleTypeArr: observable,

      loadData: action,
      deleteRecord: action,
      vehicleTypeData: action,
      addData: action,
      getFareData: action,
      getFareGridData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId, offset, limit, page }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      offset: offset,
      limit: limit,
      page: page,
    };

    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient("NodeCoreUrl")
    //   .post(
    //     "index.php?c=taxi&a=getParametersDetails",
    //     "postData=" + base64Input
    //   );

    const queryParams = {
      companyId: companyId,
      offset: offset,
      limit: limit,
      page: page,
    };
    const response = await postApi
      .getClient("NodeCoreUrl")
      .get("taxi/getParameterDetails", {
        params: queryParams,
      });

    this.taxiParameterList = response?.data?.data?.TaxiParametersData;
    // this.total = parseInt(response?.data?.TotalCount);

    this.loading = false;
  }

  async vehicleTypeData(companyId) {
    // var postData = { companyId: companyId, fairType: null };

    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient("NodeCoreUrl")
    //   .post("index.php?c=taxi&a=getVehicleType", "postData=" + base64Input);

    const response = await postApi
      .getClient("NodeCoreUrl")
      .get("taxi/getVehicleType", {
        // params: queryParams,
      });

    this.vehicleTypeArr = response.data?.data;
  }

  async addData(fareDetails) {
    var postData = fareDetails;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient("NodeCoreUrl")
    //   .post("index.php?c=taxi&a=update", "postData=" + base64Input);
    const response = await postApi
      .getClient("NodeCoreUrl")
      .post("taxi/Update", postData);

    return response?.data;
  }

  async getFareData({ parameterId, companyId }) {
    // var postData = {
    //   parameterId: parameterId,
    //   companyId: companyId,
    //   limit: 1,
    //   offset: 0,
    // };

    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient("NodeCoreUrl")
    //   .post(
    //     "index.php?c=taxi&a=getParametersDetails",
    //     "postData=" + base64Input
    //   );
    const queryParams = {
      companyId: companyId,
      mId: parameterId,
      limit: 1,
      offset: 0,
    };

    const response = await postApi
      .getClient("NodeCoreUrl")
      .get("taxi/getParameterDetails", {
        params: queryParams,
      });
    return response?.data?.data?.TaxiParametersData[0];
  }

  async getFareGridData(Id) {
    var postData = {
      Id: Id,
    };

    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient("NodeCoreUrl")
    //   .post("index.php?c=taxi&a=getGridData", "postData=" + base64Input);
    const response = await postApi
      .getClient("NodeCoreUrl")
      .get("taxi/getGridData", {
        params: postData,
      });
    return response?.data?.data;
  }

  async deleteRecord({ parameterId }) {
    const postData = { calenderId: null, parameterId: parameterId };

    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient("NodeCoreUrl")
    //   .post("index.php?c=taxi&a=delete", "postData=" + base64Input);
    var response = await postApi
      .getClient("NodeCoreUrl")
      .delete("taxi/delete?calenderId=null" + "&parameterId=" + parameterId);

    return response;
  }

  async deleteGridRecord({ Id }) {
    const postData = { Id: Id };

    var response = await postApi
      .getClient("NodeCoreUrl")
      .delete("taxi/deleteGridData?" + "Id=" + Id);

    return response;
  }
}

export default FairDetailsStore;
